import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dbcc308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex between redNote_box" }
const _hoisted_2 = { class: "charts_plan_live_color" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex receive-top" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex between" }
const _hoisted_9 = { class: "flex search-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = { style: {"min-height":"500px"} }
const _hoisted_12 = { class: "charts_plan_live_color" }
const _hoisted_13 = { class: "flex results-top" }
const _hoisted_14 = {
  key: 0,
  style: {"height":"500px"}
}
const _hoisted_15 = {
  key: 1,
  class: "results-content"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "title flex between" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { style: {"flex":"1"} }

import http from '@/api/redpacket';
import router from '@/router';
import { ref, reactive, getCurrentInstance, computed, unref } from 'vue';
import moment from 'moment';
import { getToken } from '@/plugins/cookie';
import CLoading from '@/components/CLoading.vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { Table, Pagination, Modal, DatePicker, Input, Progress, message, notification } from 'ant-design-vue';
import { onExport } from '@/components/CExport'; //导出
import { emptyDataSec } from '@/assets';
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { UploadOutlined } from '@ant-design/icons-vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';

type Key = ColumnProps['key'];
interface recordDataItem {
  id: number;
  contest_title: string;
  type_title: string;
  prize_title: string;
  amount: string;
  receive_amount: any;
  redpack_num: number;
  receive_num: number;
  created_at: string;
}

// 领取记录

export default /*#__PURE__*/_defineComponent({
  __name: 'redEnvelopeRecord',
  setup(__props) {

const { RangePicker } = DatePicker;
const aTable = Table;
const aPagination = Pagination;
const aModal = Modal;
const aRangePicker = RangePicker;
const aInputSearch = Input.Search;
const aProgress = Progress;

const { proxy }: any = getCurrentInstance();
const studioId = router.currentRoute.value.params.studioId;
const token = getToken();

const operation = reactive({
  record_time_filter: ref<Date[]>([]), // 红包记录时间筛选
  choice_all: ref(false), // 全选状态
  record_type: ref(''), // 红包记录类型
  keywords: ref(''), // 红包记录关键字
  receive_record: ref(false), // 领取记录弹窗
  receive_record_info: ref<any>({}), // 领取记录类型
  receive_time_filter: ref<Date[]>([]), // 领取记录时间筛选
  receive_record_keywords: ref(''), // 领取记录关键字
  receive_status: ref(''), // 1 未到账 2 已到账
  receiveRecordList: ref([]), // 领取记录
  answer_results: ref(false), // 答题结果弹窗
  resultsInfo: ref<any>({}), // 答题结果
  choice_arr: ref<Key[]>([]), // 勾选数组
});

const showLoading = ref<boolean>(false);

/** 红包记录 */
const recordTypes = ref([
  {
    label: '全部',
    value: '',
  },
  {
    label: '现金红包',
    value: '1',
  },
  {
    label: '自定义红包',
    value: '2',
  },
]);

const record_columns = ref([
  {
    title: '红包ID',
    dataIndex: 'id',
    align: 'center',
    fixed: 'left',
  },
  {
    title: '题库名称',
    dataIndex: 'contest_title',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '红包类型',
    align: 'center',
    dataIndex: 'type_title',
  },
  {
    title: '奖品',
    dataIndex: 'prize_title',
    align: 'center',
  },

  {
    title: '红包金额',
    dataIndex: 'amount',
    align: 'center',
    slots: {
      customRender: 'amount',
    },
  },
  {
    title: '已领取金额',
    align: 'center',
    dataIndex: 'receive_amount',
    slots: {
      customRender: 'receive_amount',
    },
  },
  {
    title: '红包个数',
    align: 'center',
    dataIndex: 'redpack_num',
  },
  {
    title: '已领取个数',
    align: 'center',
    dataIndex: 'receive_num',
  },
  {
    title: '发出时间',
    align: 'center',
    dataIndex: 'created_at',
    width: '200px',
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'operation',
    fixed: 'right',
    width: '200px',
    slots: {
      customRender: 'operation',
    },
  },
]);

// 全选
const selectedRowKeys = ref<Key[]>([]);
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const onSelectChange = (changableRowKeys: Key[]) => {
  operation.choice_arr = changableRowKeys;
  selectedRowKeys.value = changableRowKeys;
  operation.choice_all = changableRowKeys.length == recordList.value.length ? true : false;
};
const changeCheckAll = () => {
  let arr: any = [];
  operation.choice_all
    ? (recordList.value.forEach((i: any) => {
        arr.push(i.id);
      }),
      onSelectChange(arr))
    : onSelectChange([]);
};

const exportAllRecord = useDebounce((type: number) => {
  if (operation.choice_arr.length == 0) {
    message.warning(' 请选择您要导出的记录！');
    return;
  }
  const data = {
    studio_id: studioId,
    type: type,
    prize_id: selectedRowKeys.value.join(','),
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      selectedRowKeys.value = [];
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      selectedRowKeys.value = [];
      messageTip.value = res.data.error;
      openNotificationWithIcon('error');
    });
});

const recordPageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总页数
  options: ['12', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

const recordList = ref<recordDataItem[]>([]);
const receiveRecord = (item: any) => {
  operation.receive_record = true;
  operation.receive_record_info = item;
  operation.receive_record_keywords = '';
  operation.receive_status = '';
  operation.receive_time_filter = [];
  getContestReceivedList(1);
};

const receiveTypes = ref([
  {
    label: '全部',
    value: '',
  },
  {
    label: '未到账',
    value: '1',
  },
  {
    label: '已到账',
    value: '2',
  },
]);

const receive_columns = ref([
  {
    title: '红包ID',
    dataIndex: 'id',
    align: 'center',
  },
  {
    title: '观众名',
    dataIndex: 'user_name',
    align: 'center',
  },
  {
    title: '抢到时间',
    align: 'center',
    dataIndex: 'created_at',
  },
  {
    title: '手机号',
    align: 'center',
    dataIndex: 'mobile',
  },
]);

const receive_columns2 = ref([
  {
    title: '红包ID',
    dataIndex: 'id',
    align: 'center',
  },
  {
    title: '观众名',
    dataIndex: 'user_name',
    align: 'center',
  },
  {
    title: '抢到时间',
    align: 'center',
    dataIndex: 'created_at',
  },
  {
    title: '抢到金额',
    align: 'center',
    dataIndex: 'amount',
    slots: {
      customRender: 'amount',
    },
  },
]);

const receiveRecordConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 1, // 总页数
});

// 竞答红包领取记录
const getContestReceivedList = (current: number) => {
  let params = {
    studio_id: studioId,
    prize_id: operation.receive_record_info.id,
    type: operation.receive_record_info.type,
    keywords: operation.receive_record_keywords,
    state_time: operation.receive_time_filter[0] ? new Date(operation.receive_time_filter[0]) : operation.receive_time_filter[0],
    end_time: operation.receive_time_filter[0] ? new Date(operation.receive_time_filter[0]) : operation.receive_time_filter[0],
    receive: operation.receive_status,
    page: current,
    page_num: receiveRecordConfig.totalSize,
  };
  receiveRecordConfig.current = current;
  showLoading.value = true;
  http
    .getContestReceivedList({ params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        operation.receiveRecordList = res.data.data.data;
        receiveRecordConfig.totalSize = res.data.data.total;
      }
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

// 答题结果
const answerResults = (item: any) => {
  operation.answer_results = true;
  getContestAnswerRecord(item.id);
};

// 答题结果
const getContestAnswerRecord = (prize_id: any) => {
  let params = {
    studio_id: studioId,
    prize_id: prize_id,
  };
  showLoading.value = true;
  http
    .getContestAnswerRecord({ params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        operation.resultsInfo = res.data.data;
      }
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

// 导出记录
const corn = ref(1);
const messageTip = ref();
const exportRecord = useDebounce((type: number) => {
  const data = {
    studio_id: studioId,
    type: type,
    prize_id: operation.receive_record_info.id,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error;
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
    duration: 5,
  });
};

// 获取红包记录
const contestRdpackList = (current: number) => {
  let params = {
    studio_id: studioId,
    keywords: operation.keywords,
    type: operation.record_type,
    state_time: operation.record_time_filter[0] ? new Date(operation.record_time_filter[0]) : operation.record_time_filter[0],
    end_time: operation.record_time_filter[1] ? new Date(operation.record_time_filter[1]) : operation.record_time_filter[1],
    page: current,
    page_num: recordPageConfig.pageSize,
  };
  recordPageConfig.current = current;
  showLoading.value = true;
  http
    .contestRdpackList({ params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        recordList.value = res.data.data.data;
        recordPageConfig.totalSize = res.data.data.total;
      }
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

const init = () => {
  contestRdpackList(1);
};

init();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_unref(aRangePicker), {
          ranges: {
            今天: [_unref(moment)().startOf('day'), _unref(moment)().endOf('day')],
            最近一周: [_unref(moment)().startOf('day').subtract(1, 'weeks'), _unref(moment)()],
            最近一月: [_unref(moment)().startOf('day').subtract(1, 'months'), _unref(moment)()],
            最近三月: [_unref(moment)().startOf('day').subtract(3, 'months'), _unref(moment)()],
          },
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          value: operation.record_time_filter,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((operation.record_time_filter) = $event)),
          class: "mod_range_picker container_textLeft_picker",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (contestRdpackList(1)))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["ranges", "value"]),
        _createVNode(_component_a_select, {
          class: "select mod_select",
          options: recordTypes.value,
          placeholder: "全部",
          value: operation.record_type,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((operation.record_type) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (contestRdpackList(1)))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["options", "value"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_a_checkbox, {
          class: "checkbox",
          checked: operation.choice_all,
          "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((operation.choice_all) = $event)),
          onChange: changeCheckAll
        }, {
          default: _withCtx(() => [
            _createTextVNode("全选")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "export_btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(exportAllRecord)(20)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 导出 ")
          ]),
          _: 1
        }),
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search margin-b",
          value: operation.keywords,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((operation.keywords) = $event)),
          placeholder: "请输入关键字",
          onChange: _cache[7] || (_cache[7] = ($event: any) => (contestRdpackList(1)))
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(_unref(aTable), {
      loading: showLoading.value,
      columns: record_columns.value,
      scroll: { x: 1500, y: 0 },
      "data-source": recordList.value,
      pagination: false,
      "row-selection": _unref(rowSelection),
      class: "table-list",
      rowKey: 
        (res) => {
          return res.id;
        }
      
    }, {
      amount: _withCtx(({ record }) => [
        _createElementVNode("span", _hoisted_2, "¥" + _toDisplayString(record.amount), 1)
      ]),
      operation: _withCtx(({ record }) => [
        _createElementVNode("span", {
          class: "cursor primary_color",
          style: {"margin-right":"20px"},
          onClick: ($event: any) => (receiveRecord(record))
        }, "领取记录", 8, _hoisted_3),
        _createElementVNode("span", {
          class: "cursor primary_color",
          onClick: ($event: any) => (answerResults(record))
        }, "答题结果", 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["loading", "columns", "data-source", "row-selection", "rowKey"]),
    _createVNode(_unref(aPagination), {
      "show-quick-jumper": "",
      total: recordPageConfig.totalSize,
      current: recordPageConfig.current,
      "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((recordPageConfig.current) = $event)),
      "page-size": recordPageConfig.pageSize,
      "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((recordPageConfig.pageSize) = $event)),
      pageSizeOptions: recordPageConfig.options,
      "show-less-items": "",
      "show-size-changer": "",
      onChange: _cache[10] || (_cache[10] = ($event: any) => (contestRdpackList(recordPageConfig.current))),
      onShowSizeChange: _cache[11] || (_cache[11] = ($event: any) => (contestRdpackList(recordPageConfig.current)))
    }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]),
    _createVNode(_unref(aModal), {
      visible: operation.receive_record,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((operation.receive_record) = $event)),
      title: "领取记录",
      class: "bill-model",
      width: "900px",
      okText: "导出记录",
      onOk: _cache[22] || (_cache[22] = ($event: any) => (_unref(exportRecord)(20))),
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(" 题库名称： "),
            _createElementVNode("span", null, _toDisplayString(operation.receive_record_info.contest_title), 1)
          ]),
          _createElementVNode("p", null, "红包类型：" + _toDisplayString(operation.receive_record_info.type_title), 1),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(" 奖品： "),
            _createElementVNode("span", null, _toDisplayString(operation.receive_record_info.prize_title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (operation.receive_record_info.type == 1)
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 0,
                  class: "select mod_select",
                  options: receiveTypes.value,
                  placeholder: "全部",
                  value: operation.receive_status,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((operation.receive_status) = $event)),
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (getContestReceivedList(1)))
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "mod_select_icon",
                      "icon-class": "list_select"
                    })
                  ]),
                  _: 1
                }, 8, ["options", "value"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(aRangePicker), {
              ranges: {
              今天: [_unref(moment)().startOf('day'), _unref(moment)().endOf('day')],
              最近一周: [_unref(moment)().startOf('day').subtract(1, 'weeks'), _unref(moment)()],
              最近一月: [_unref(moment)().startOf('day').subtract(1, 'months'), _unref(moment)()],
              最近三月: [_unref(moment)().startOf('day').subtract(3, 'months'), _unref(moment)()],
            },
              "show-time": { format: 'HH:mm' },
              format: "YYYY-MM-DD HH:mm",
              value: operation.receive_time_filter,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((operation.receive_time_filter) = $event)),
              class: "mod_range_picker container_textLeft_picker",
              onChange: _cache[15] || (_cache[15] = ($event: any) => (getContestReceivedList(1)))
            }, {
              suffixIcon: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
              ]),
              _: 1
            }, 8, ["ranges", "value"]),
            _createVNode(_unref(aInputSearch), {
              class: "mod_range_picker_search margin-b",
              value: operation.receive_record_keywords,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((operation.receive_record_keywords) = $event)),
              placeholder: "请输入关键字",
              onChange: _cache[17] || (_cache[17] = ($event: any) => (getContestReceivedList(1)))
            }, {
              enterButton: _withCtx(() => [
                _createVNode(_unref(SearchOutlined))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(aTable), {
            loading: showLoading.value,
            columns: operation.receive_record_info.type == 2 ? receive_columns.value : receive_columns2.value,
            "data-source": operation.receiveRecordList,
            pagination: false,
            rowKey: 
            (res) => {
              return res.id;
            }
          ,
            bordered: ""
          }, {
            amount: _withCtx(({ record }) => [
              _createElementVNode("span", _hoisted_12, "+" + _toDisplayString(record.amount), 1),
              _createElementVNode("span", null, _toDisplayString(record.receive == 1 ? '/ 未到账' : '/ 已到账'), 1)
            ]),
            _: 1
          }, 8, ["loading", "columns", "data-source", "rowKey"])
        ]),
        _createVNode(_unref(aPagination), {
          style: {"margin-top":"10px"},
          total: receiveRecordConfig.totalSize,
          current: receiveRecordConfig.current,
          "onUpdate:current": _cache[18] || (_cache[18] = ($event: any) => ((receiveRecordConfig.current) = $event)),
          "page-size": receiveRecordConfig.pageSize,
          "onUpdate:pageSize": _cache[19] || (_cache[19] = ($event: any) => ((receiveRecordConfig.pageSize) = $event)),
          pagination: receiveRecordConfig,
          onChange: _cache[20] || (_cache[20] = ($event: any) => (getContestReceivedList(receiveRecordConfig.current))),
          "show-less-items": ""
        }, null, 8, ["total", "current", "page-size", "pagination"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: operation.answer_results,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((operation.answer_results) = $event)),
      title: "答题结果",
      class: "bill-model",
      width: "900px",
      footer: null,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, "题库名称：" + _toDisplayString(operation.resultsInfo.title), 1),
          _createElementVNode("p", null, "全对人数：" + _toDisplayString(operation.resultsInfo.all_right), 1),
          _createElementVNode("p", null, "答题人数：" + _toDisplayString(operation.resultsInfo.all_people), 1),
          _createElementVNode("p", null, "抢到红包人数：" + _toDisplayString(operation.resultsInfo.all_red_pack), 1)
        ]),
        (showLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(CLoading)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (!operation.resultsInfo.question_list)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_a_empty, {
                      class: "empty_wrap",
                      image: _unref(emptyDataSec),
                      description: "页面暂无数据信息~"
                    }, null, 8, ["image"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operation.resultsInfo.question_list, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "results-item",
                  key: index + '-only'
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", null, _toDisplayString(item.question_title) + "（" + _toDisplayString(item.question_type == 1 ? '单选' : '多选') + "）", 1),
                    _createElementVNode("p", null, "使用复活卡数：" + _toDisplayString(item.resurrection), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.question_answer, (i, j) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content flex between",
                      key: j
                    }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" 选项" + _toDisplayString(j + 1) + "：" + _toDisplayString(i.answer_title) + " ", 1),
                        (i.answer_options == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "（正确答案）"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_unref(aProgress), {
                          percent: i.proportion,
                          steps: 5
                        }, null, 8, ["percent"])
                      ]),
                      _createElementVNode("span", null, "(" + _toDisplayString(i.optuions) + "票)", 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})